import { ActionTree, MutationTree } from 'vuex'
import _get from 'lodash/get'
import instance from '../connection'

class State {
  groups: [IGroup] | [] = []
  total: number = 0
  pagination = {
    current: 1 as number,
    pageSize: 10 as number,
    total: 0 as number
  }
  sorter = {
    field: '' as string,
    order: '' as string
  }
  organization: string | undefined = undefined
  groupList: {id: string, name: string} [] | [] = []
}

const getters = {
  //
}

const actions = <ActionTree<State, any>>{
  async getGroups({ commit, state }) {
    let params: any = {
      page: state.pagination.current,
      limit: state.pagination.pageSize,
      sort: state.sorter.field,
      order: state.sorter.order
    }
    if (state.organization) {
      params.org = state.organization
    }
    return commit('updateGroups', await instance.get('/group', { params }))
  },
  async listGroup({ commit }, org: string | null = null) {
    let params = {}
    if (org) {
      params = { org }
    }
    return commit('updateGroupList', await instance.get('/group/list', { params }))
  },
  async deleteGroup({ dispatch }, id) {
    await instance.delete('/group/' + id)
    return await dispatch('getGroups')
  },
  async updateGroup({ dispatch }, group:any) {
    await instance.put('/group/' + group.id, group)
    return await dispatch('getGroups')
  },
  async addGroup({ dispatch }, group:any) {
    await instance.post('/group', group)
    return await dispatch('getGroups')
  },
}

const mutations = <MutationTree<State>>{
  updateGroups(state, records) {
    state.groups = records.data
    state.total = records.total
    state.pagination.total = records.total
  },
  updateGroupPagination(state, {current, pageSize, total}) {
    if (current) state.pagination.current = current
    if (pageSize) state.pagination.pageSize = pageSize
    if (total) state.pagination.total = total
  },
  updateGroupSorter(state, {field, order}) {
    if (field) state.sorter.field = field
    if (order) state.sorter.order = order
  },
  updateCurrentGroupOrg(state, organization) {
    state.organization = organization
  },
  updateGroupList(state, list) {
    state.groupList = list
  },
}

interface IGroup {
  name: string
  mobile: string
}

export default {
  state: new State(),
  getters,
  actions,
  mutations
}